<template>
  <portal to="modals">
    <div class="modal-overlay" @click="closeModal">
      <div class="modal-container" @click.stop>
        <div class="room-info-modal-header">
          <div class="d-flex align-items-center">
            <h2 class="modal-title raleway-reg-p24">Détails de la chambre</h2>
            <div class="btn-galerie">
              <div class="galerie-icon df-jsb-aic justify-content-center">
                <img src="../../images/Galerie icone.svg" v-set-alt />
                <p class="raleway-semi-p13 mb-0 ml-1" @click="showModalRoomGalery">Galerie</p>
              </div>
            </div>
          </div>
          <button class="modal-close" @click="closeModal">
            <i class="fa fa-times"></i>
          </button>
        </div>
        
        <div class="modal-content">
          <!-- Swiper Slider for Both Desktop and Mobile -->
          <div class="room-image-slider-container" :class="{ 'desktop-slider': !isPhone }">
            <div class="swiper-container room-modal-slider">
              <div class="swiper-wrapper">
                <div
                  v-for="(photo, index) in getAllRoomPhotos(room)"
                  :key="`modal_room_${room.id}_${index}`"
                  class="swiper-slide"
                  :style="{ backgroundImage: `url('${photo}')` }"
                >
                </div>
              </div>
              <div class="swiper-button-next" @click.stop></div>
              <div class="swiper-button-prev" @click.stop></div>
              <div class="swiper-pagination"></div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-8 col-md-12 lodging-room-info">
              <div class="d-flex" :class="isPhone ? 'align-items-start' : 'align-items-center'">
                <h3 class="raleway-semi-p15 mb-0">{{ room.name }}</h3>
                <p class="raleway-medi-p15 mb-0 ml-2">{{ room.capacity }}</p>
                <img
                  src="../../images/profil.svg"
                  v-set-alt
                  style="width: 14px; height: 14px;"
                />
              </div>

              <div class="room-details mt-2 raleway-reg-p15">
                <p v-if="room.number_of_rooms">
                  {{ room.number_of_rooms }} {{ room.number_of_rooms === 1 ? 'chambre' : 'chambres' }}
                </p>
                <p v-if="room.bed_type">{{ room.bed_type }}</p>
                <p v-if="room.area">Superficie {{ room.area }}m²</p>
                <p v-if="room.view_on">{{ room.view_on }}</p>
                <p>Capacité {{ room.capacity }} personnes</p>
              </div>
            </div>
            <div class="d-flex col-lg-4 col-md-12" :class="isPhone ? 'align-items-start w-100 mt-2' : 'flex-column align-items-end'" v-if="room.lowest_price">
              <p class="raleway-reg-p15 mb-0">À partir de</p>
              <p class="raleway-semi-p15 mb-0" :class="isPhone ? 'ml-2 mr-2' : ''">{{ room.lowest_price }} EUR</p>
              <p class="raleway-reg-p13 mb-0">par nuit</p>
            </div>
          </div>
        </div>
          
        <!-- HR Line -->
        <hr class="divider mx-4" v-if="room.service_rooms && room.service_rooms.length > 0"/>
          
        <!-- Room Services -->
        <div class="room-services mb-3" v-if="room.service_rooms && room.service_rooms.length > 0">
          <p class="equipments-title raleway-semi-p15">Équipements</p>
          <ul class="equipments-list">
            <li
              v-for="service in room.service_rooms"
              :key="service.id"
              class="equipment-item raleway-reg-p15"
            >
              {{ service.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    
    <!-- Image Gallery Modal -->
    <ImageSliderModal
      v-if="showImageGallery && !isPhone"
      :images="getAllRoomPhotos(room)"
      :initialIndex="selectedImageIndex"
      @close="closeImageGallery"
    />
  </portal>
</template>

<script>
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper.min.css';
import 'swiper/modules/navigation.min.css';
import 'swiper/modules/pagination.min.css';
import ImageSliderModal from './ImageSliderModal.vue';

Swiper.use([Navigation, Pagination]);

export default {
  name: 'RoomDetailsModal',
  components: {
    ImageSliderModal
  },
  props: {
    room: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isPhone: window.innerWidth <= 768,
      swiperInstance: null,
      showImageGallery: false,
      selectedImageIndex: 0,
    };
  },
   computed: {},
   mounted() {
     this.$nextTick(() => {
       this.initializeSwiper();
     });
   },
  methods: {
     initializeSwiper() {
       const sliderElement = document.querySelector('.room-modal-slider');
       if (sliderElement) {
         this.swiperInstance = new Swiper('.room-modal-slider', {
           modules: [Navigation, Pagination],
           slidesPerView: this.isPhone ? 1 : 2,
           spaceBetween: this.isPhone ? 0 : 10,
           pagination: {
             el: '.room-modal-slider .swiper-pagination',
             type: "bullets",
             clickable: true,
           },
           navigation: {
             nextEl: '.room-modal-slider .swiper-button-next',
             prevEl: '.room-modal-slider .swiper-button-prev',
           },
           loop: true,
           touchRatio: 1,
           touchAngle: 45,
           allowTouchMove: true,
         });
       }
     },
    destroySwiper() {
      if (this.swiperInstance && this.swiperInstance.destroy) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    },
     closeModal() {
       this.$emit('close');
     },
    showModalRoomGalery() {
      this.$emit('show-room-galery');
    },
    getAllRoomPhotos(room) {
      const fallbackImage = 'https://media.gettyimages.com/photos/bedroom-in-new-luxury-home-picture-id1194686012?k=6&m=1194686012&s=612x612&w=0&h=IX6Bjhwa5M5NtCtlKll-FFi_hn5lxrPwiUImH3fsZZ0=';
      const photos = [];
      
      // Add photo_banner first if available
      if (room?.photo_banner?.trim() && room.photo_banner !== 'null' && room.photo_banner !== 'undefined') {
        photos.push(room.photo_banner.trim().replace(/['"]/g, ''));
      }
      
      // Add photos from photos_keys
      if (room?.photos_keys && Array.isArray(room.photos_keys) && room.photos_keys.length > 0) {
        room.photos_keys.forEach(photo => {
          const photoURL = photo.url || photo;
          if (photoURL && photoURL.trim && photoURL.trim() && photoURL !== 'null' && photoURL !== 'undefined') {
            const cleanURL = photoURL.trim().replace(/['"]/g, '');
            if (!photos.includes(cleanURL)) {
              photos.push(cleanURL);
            }
          }
        });
      }
      
      // If no photos found, return fallback
      return photos.length > 0 ? photos : [fallbackImage];
    }
  },
  beforeDestroy() {
    this.destroySwiper();
  }
};
</script>

<style scoped lang="scss">
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 20px;
}

.modal-container {
  background: white;
  border-radius: 12px;
  max-width: 969px;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.room-info-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 32px;
  border: unset !important;
  
  .modal-title {
    margin: 0;
    color: #333;
  }
  
  .modal-close {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #666;
    padding: 8px;
    border-radius: 50%;
    transition: all 0.2s ease;
  }
}

.modal-content {
  border: unset !important;
  padding: 10px 32px 0px 32px;
}



.divider {
  border: none;
  height: 1px;
  background-color: #e0e0e0;
  margin: 16px 0;

  @media screen and (max-width: 768px) {
    margin-top: 0;
    margin-bottom: 16px;
  }
}

.room-services {
  .equipments-title {
    margin-bottom: 20px;
    color: #333;
    font-weight: 600;
  }
  
  .equipments-list {
    display: flex;
    flex-wrap: wrap;
    list-style: disc;
    padding-left: 20px;
    margin: 0;
    
    .equipment-item {
      width: calc(33.333% - 10px);
      margin-right: 10px;
      margin-bottom: 8px;
      box-sizing: border-box;
    }
  }
}

// Mobile responsiveness
@media (max-width: 768px) {
  .modal-overlay {
    padding: 10px;
  }
  
  .modal-container {
    margin: 0;
    max-height: 95vh;
    width: 100%;
    max-width: 100%;
  }
  
  .room-info-modal-header {
    padding: 15px 20px;
    flex-direction: row;
    align-items: center;
    position: relative;
    
    .d-flex {
      width: 100%;
      justify-content: flex-start;
      align-items: center;
    }
    
    .modal-title {
      font-size: 18px;
    }
    
    .btn-galerie {
      display: none;
    }
    
    .modal-close {
      position: absolute;
      top: 15px;
      right: 20px;
    }
  }
  
  .modal-content {
    padding: 15px 20px;
  }
  
  .room-services {
    padding: 0px 20px 20px 20px;
  }
  
  .equipments-list {
    .equipment-item {
      width: calc(50% - 5px);
      font-size: 14px;
    }
  }
}

@media (max-width: 480px) {
  .modal-overlay {
    padding: 5px;
  }
  
  .modal-container {
    border-radius: 8px;
  }
  
  .room-info-modal-header {
    padding: 10px 15px;
    
    .modal-title {
      font-size: 16px;
    }
    
    .modal-close {
      top: 0px;
      right: 10px;
    }
  }
  
  .modal-content {
    padding: 10px 15px;
  }
  
  .room-services {
    padding: 0px 15px 15px 15px !important;
  }
  
  .equipments-list {
    .equipment-item {
      width: calc(45% - 5px) !important;
      margin-right: 5px;
    }
  }
}

.lodging-room-info {
  display: flex;
  flex-direction: column;
  justify-content: center;

  .room-details {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }

  .room-details p {
    margin: 0;
    display: flex;
    align-items: center;
    position: relative;
  }

  .room-details p:not(:last-child)::after {
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    margin-left: 8px;
    background: #000000;
    border: 1px solid #000000;
    border-radius: 50%;
  }
}

.room-services {
  padding: 0px 32px 32px 32px;
}

.btn-galerie {
  display: block;
  margin-left: 1rem;
  .galerie-icon {
    border-radius: 60px;
    padding: 1rem 2rem;
    width: 120px;
    height: 34px;
    background: #000000 0% 0% no-repeat padding-box;
    opacity: 0.6;
    color: white;
    cursor: pointer;
  }
}

// Swiper Slider Styles for Mobile and Desktop
.room-image-slider-container {
  width: 100%;
  height: 250px;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  margin-bottom: 15px;
  
  // Desktop: 2 images per view with maintained height
  &.desktop-slider {
    height: 388px;
  }
}

.room-modal-slider {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  
  .swiper-slide {
    height: 250px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-color: #f0f0f0;
    border-radius: 10px;
  }
  
  // Desktop: maintain height for all slides
  .desktop-slider & .swiper-slide {
    height: 388px;
  }
  
  .swiper-button-prev, .swiper-button-next {
    top: 50% !important;
    width: 20px !important;
    height: 20px !important;
    cursor: pointer;
    border-radius: 50%;
    outline: 0;
    background: rgba(0, 0, 0, 0.5) !important;
    padding: 0.5rem;
    transition: all 0.3s ease;
    opacity: 1;
    z-index: 10;

    @media screen and (min-width: 769px) {
      &:hover {
        background-color: rgba(255, 255, 255, 0.9) !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        transform: scale(1.05);
      }
    }

    &:after {
      font-size: 10px;
      color: white;
      z-index: 10;
    }
  }

  .swiper-pagination {
    bottom: 10px !important;
    
    .swiper-pagination-bullet {
      background: rgba(255, 255, 255, 0.7);
      opacity: 1;
      width: 8px;
      height: 8px;
      
      &.swiper-pagination-bullet-active {
        background: white !important;
      }
    }
  }
}

@media (max-width: 480px) {
  .room-image-slider-container {
    height: 200px;
  }
  
  .room-modal-slider .swiper-slide {
    height: 200px;
  }
}
</style>